'use strict';
var $export = require('./_export')
  , $map    = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */){
    return $map(this, callbackfn, arguments[1]);
  }
});


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/core-js/modules/es6.array.map.js
// module id = 644
// module chunks = 1